/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupstatuscancelled2Inputs */

const en_signupstatuscancelled2 = /** @type {(inputs: Signupstatuscancelled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

const de_signupstatuscancelled2 = /** @type {(inputs: Signupstatuscancelled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgemeldet`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Signupstatuscancelled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupstatuscancelled2 = /** @type {((inputs?: Signupstatuscancelled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupstatuscancelled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupstatuscancelled2(inputs)
	return de_signupstatuscancelled2(inputs)
});
export { signupstatuscancelled2 as "signupStatusCancelled" }